import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import AdminRouter from './admin/routes';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
const isAdminPath = window.location.pathname.startsWith('/admin');

root.render(
  <React.StrictMode>
    {isAdminPath ? (
      <AdminRouter />
    ) : (
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )}
  </React.StrictMode>
);
